<img
  [src]="'assets/icons/material/' + name + '.svg'"
  [width]="size"
  [height]="size"
  [alt]="name + '_icon'"
/>
